import React from "react";
import { FraudCheckboxStyles } from "../styles/Inputs";
import PropTypes from "prop-types";

const FraudCheckbox = ({ checked, onChange, name, value, title, disabled, info }) => {
  return (
    <FraudCheckboxStyles disabled={disabled} title={info}>
      <input
        checked={checked}
        type="checkbox"
        name={name}
        title={title}
        disabled={disabled}
        value={value}
        onChange={onChange}
      />
      <div className="checkmark-container">
        <p>{title}</p> <div className="checkmark" />
      </div>
    </FraudCheckboxStyles>
  );
};

FraudCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  info: PropTypes.string,
};

export default FraudCheckbox;
